import React from 'react';
import './skeletons.css';
import Shimmer from './shimmer'

function SkeletonElement({ type }) {
    const classes = `skeleton ${type}`;

    return (
        <div className={classes}>
            <Shimmer />
        </div>
    )
}

export default SkeletonElement